import { useEffect, useState } from 'react';
import Select from 'react-select';

function PermissionModuleFilter(props) {
  const [customOptionList, setCustomOptionList] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    if (Array.isArray(props.moduleMenuList) && props.moduleMenuList.length > 0) {
      const options = props.moduleMenuList.map((module) => ({
        value: module.module_id,
        label: module.module_name,
        fullModule: module,
      }));

      setCustomOptionList(options);

      // Set default value if provided
      if (props.defaultVal !== undefined) {
        const defaultOption = options.find(
          (opt) => opt.value === props.defaultVal
        );
        setSelectedOption(defaultOption || null);
      }
    } else {
      setCustomOptionList([]);
    }
  }, [props.moduleMenuList, props.defaultVal]);

  const handleChange = (selected) => {
    setSelectedOption(selected);
    props?.onModuleSelect?.(selected?.fullModule || null);
  };

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 42,
      width: 250,
    }),
    indicatorSeparator: (styles) => ({
      ...styles,
      display: 'none',
    }),
    valueContainer: (styles) => ({
      ...styles,
      paddingBottom: '4px',
      marginLeft: '5px',
    }),
    option: (styles) => ({
      ...styles,
      color: 'black',
    }),
    menuPortal: (styles) => ({
      ...styles,
      zIndex: 9999,
    }),
  };

  return (
    <div style={{ width: '300px' }}>
      <Select
        menuPlacement="auto"
        menuPosition="fixed"
        options={customOptionList}
        value={selectedOption}
        onChange={handleChange}
        styles={customStyles}
        isClearable
        placeholder="Select Module"
      />
    </div>
  );
}

export default PermissionModuleFilter;
